// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f49b629c","688":"a60da610"}[chunkId] + ".chunk.js";
};